import { useTranslation } from "react-i18next";
import { Button } from "@acdc2/ui/components/button";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@acdc2/ui/components/card";

type Props = {
  title: string;
  description: string;
  onConvert: () => void;
};

export function RegionTypeCard({ title, description, onConvert }: Props) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardFooter>
        <Button className="w-full" onClick={onConvert}>
          {t("RegionTypeCard.button.label")}
        </Button>
      </CardFooter>
    </Card>
  );
}
